import {
  queryOptions,
  useMutation,
  useQueryClient,
} from '@mint-lib/query-client';
import { Chat, KnowledgeBase } from '@mint-sdk/api-ai-assistant';

export const REFETCH_PROCESSED_FILES = 15_000;

export const getDocumentsOption = () => {
  return queryOptions({
    ...Chat.listRagDocuments({}),
    refetchInterval: (query) => {
      const { data } = query.state;

      const isAllDocumentProcessed =
        data?.findIndex((d) => d.status === 'pending') === -1;

      if (isAllDocumentProcessed) {
        return false;
      }

      return REFETCH_PROCESSED_FILES;
    },
  });
};

// The file endpoints carry no SDK `onSuccess`, so the folder listing holding
// the same files behind `aiFileSystem` is refreshed here. With the flag off the
// listing query is disabled and this is a no-op.
export const useLoadDocumentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: Chat.DocumentUploadRequestType) =>
      Chat.loadNewRagDocument({
        data,
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    onSettled: () =>
      KnowledgeBase.getKnowledgeBaseListing.invalidateAll(queryClient, {}),
  });
};

export const useDeleteDocumentMutation = () => {
  const queryClient = useQueryClient();
  const { queryKey: getDocumentQueryKey } = Chat.listRagDocuments({});

  return useMutation({
    mutationFn: (documentId: string) =>
      Chat.deleteRagDocument({ urlParams: { documentId } }),
    onMutate: async (fileId) => {
      const previousDocs: Chat.RagDocumentType[] | undefined =
        queryClient.getQueryData(getDocumentQueryKey);
      queryClient.setQueryData(
        getDocumentQueryKey,
        (old?: Chat.RagDocumentType[]) =>
          old?.filter((f) => f.fileId !== fileId),
      );

      return { previousDocs };
    },
    onError: (_error, _fileId, context) => {
      queryClient.setQueryData(getDocumentQueryKey, context?.previousDocs);
    },
  });
};
